import toast from "react-hot-toast";
import useCreate from "../useCreate";

const useApproveRejectApplication = ({ onSuccess, refreshUrl = "business/list" }) => {
  const { setDataToServer: approveRejectReq } = useCreate({
    url: "business/approval_status_update",
    refreshUrl: refreshUrl,
    onSuccess: (_, reqParams) => {
      if (reqParams.approval_status === "approved") {
        toast.success("Application approved successfully");
      } else {
        toast.success("Application rejected successfully");
      }
      onSuccess?.();
    },
    onError: (err) => {
      toast.error("Error updating application status: " + err?.message);
    },
  });
  const isLoading = approveRejectReq.isLoading;

  const handleApprove = (applicationId, reason) => {
    // Logic to approve the application
    approveRejectReq.mutate({
      business_id: applicationId,
      approval_status: "approved",
      reason: reason,
    });
  };

  const handleReject = (applicationId, reason) => {
    // Logic to reject the application
    approveRejectReq.mutate({
      business_id: applicationId,
      approval_status: "rejected",
      reason: reason,
    });
  };

  return {
    handleApprove,
    isLoading,
    handleReject,
  };
};

export default useApproveRejectApplication;
